
export default [    
    {
        path:'/serveList',
        name:'serveList',
        component: () => import('@/page/serve/serveList')
    },
    {
        path:'/serveDetail',
        name:'serveDetail',
        component: () => import('@/page/serve/serveDetail')
    },
    {
        path:'/serve-upload',
        name:'serve-upload',
        component: () => import('@/page/serve/serve-upload')
    },
  
  ]